import $ from '@ali/tarzan-zepto';
import util from '../../../lib/util.js';
import tpl from './tpl.html';
import './style.scss';

const LOG_C = 'knowledge';
let app = null;
const TAP = util.isPC() ? 'click' : 'tap';

/**
 * 前端mock机器人发一句话 并保存
 */
function sendAndSaveMessage(text) {
  const user = app.appConfig.get('user');
  app.postMessage({
    type: 'robot',
    body: {
      text,
    },
  }).then((res) => {
    app.view.body.append(res.body);
  });
  app.model.saveMessageLog({
    content: text,
    type: 'MSG',
    senderId: 119,
    senderName: 'robot',
    senderType: 4,
    userId: user.userId,
  });
}

/**
 * 反问用户不满意的原因，并保持用户输入的内容
 */
function saveFeedback(data) {
  app.view.setReceiver((d, type, show, post) => {
    const text = app.util.isObject(d) ? d.q : d;
    const user = app.appConfig.get('user');
    if (show) {
      app.appendMessage({
        type: 'consumer',
        body: {
          type,
          text,
          userId: 1,
        },
      });
    }

    if (post) {
      app.model.robotRate({
        chatUuid: data.chatUuid,
        suggestion: text,
      });
      app.model.saveMessageLog({
        content: text,
        type: 'MSG',
        senderId: user.userId,
        senderName: user.nick,
        senderType: 1,
        userId: user.userId,
      });
    }
    sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:FEEDBACK'));

    // 显示转人工入口
    app.shortcuts.push({
      isAdd: true,
      shortcuts: [{
        code: 'dispatch',
        icon: 'service',
        means: {
          type: 'dispatch',
          content: JSON.stringify({
            skillGroupId: data.skillGroup,
            question: data.question,
          }),
        },
        name: app.util.lang.get('SHORTCUT:DISPATCH'),
      }],
    });
    // 切换到机器人
    app.channel.robot.online();
  });
}

function onClickRate(ev, data) {
  const $target = $(ev.currentTarget);
  const switches = app.appConfig.get('switches');
  const rate = $target.hasClass('good') ? 'good' : 'bad';
  const showManual = data.skillGroup && !switches.hideCommentManualEntrance;
  // 已经评价过，do nothing
  if ($target.hasClass('rated')) {
    return;
  }
  app.log.send({
    c: LOG_C,
    d: rate,
  });
  // 发请求，记录评价结果
  app.model.robotRate({
    value: rate === 'good' ? 1 : 0,
    chatUuid: data.chatUuid,
  });
  $target.addClass('rated');

  $target.siblings().remove();
  $target.find('use').attr('xlink:href', `#icon-f${rate}`);

  if (rate === 'bad') {
    if (showManual) {
      sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:ASK'));
      // 保存用户的评价
      saveFeedback(data);
    } else {
      sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:BAD'));
    }
  } else {
    sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:GOOD'));
  }
}

function bindEvents(data, $node) {
  $node.find('.J_Btn').on(TAP, ev => onClickRate(ev, data));
}

export default function knowledgerate(data) {
  // console.log(data);
  app = this;
  const $node = $(tpl.render(data));
  bindEvents(data, $node);
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/knowledgerate/index.js